import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=dafe2b98&scoped=true&"
import script from "./BaseData.vue?vue&type=script&lang=js&"
export * from "./BaseData.vue?vue&type=script&lang=js&"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=dafe2b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafe2b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dafe2b98')) {
      api.createRecord('dafe2b98', component.options)
    } else {
      api.reload('dafe2b98', component.options)
    }
    module.hot.accept("./BaseData.vue?vue&type=template&id=dafe2b98&scoped=true&", function () {
      api.rerender('dafe2b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/BaseData.vue"
export default component.exports